import { render, staticRenderFns } from "./PersonnelIntroduction.vue?vue&type=template&id=24acdc9d&"
import script from "./PersonnelIntroduction.vue?vue&type=script&lang=js&"
export * from "./PersonnelIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelIntroduction.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports